import {GET_WEATHER_DATA,GET_TIME} from '../constants/data'

const reducer = (state={currentData:{},time:null},action)=>{
    switch(action.type){
        case GET_WEATHER_DATA:
           // console.log(action.payload);
            return{...state,currentData:action.payload};

        case GET_TIME:
            return{...state,time:action.payload};

        default:
            return state;
    }
}

export default reducer